import { DdpImage } from "@/components/shared/DdpImage"
import { TDdpMedia } from "@/shared/types";

export function Error(props: {
    title: string;
    error404: string;
    goBack: string;
    seeWrong: string;
    image: Array<TDdpMedia>
}) {
    const { title, error404, goBack, seeWrong, image } = props
    return (
        <div className={`page-not-found`}>
            <div className="top-label">{title}</div>
            <div className="content-wrapper">
                <h1 className="title">{error404}</h1>
                <DdpImage className="image" image={image} />
                <div className="description">{seeWrong}</div>
                <div className="msg">{goBack}</div>
            </div>

        </div>
    )
}